<template>
    <div
        class="apprentice-simple-card categories-management"
        v-if="loaded">
        <div class="muted-text categories-management-description">
            {{ $t('school.the_categories_below_can_be_used_by_the_students_for_their_personal_timeline') }}
        </div>

        <design-2021-apprentice-data-table
            class="categories-management-overview-table"
            :items="categories"
            :fields="fields">
            <template v-slot:options>
                <b-button
                    class="btn-admin-users"
                    v-b-modal="'school-settings-add-category'"
                    variant="primary">
                    <i class="fas fa-plus fa-fw"></i>
                    {{ $t('school.new_category') }}
                </b-button>

                <design-2021-school-settings-profile-categories-add-modal-component></design-2021-school-settings-profile-categories-add-modal-component>
            </template>

            <template #cell(color)="data">
                <div
                    class="color-icon"
                    :style="cssVars(data.item.color)">
                    <i
                        class="fas fa-circle"
                        v-b-tooltip.hover
                        :title="$t('school.color_code', { code: data.item.color })"></i>
                </div>
            </template>

            <template v-slot:cell(description)="data">
                <design-2021-apprentice-display-html-component
                    class="description"
                    :html-content="data.item.description">
                </design-2021-apprentice-display-html-component>
            </template>

            <template v-slot:cell(actions)="data">
                <div class="actions">
                    <b-button
                        class="btn-settings"
                        v-b-modal="'school-settings-edit-category' + data.item.id"
                        variant="primary-icon-only"
                        :v-b-tooltip="$t('common.edit')"></b-button>

                    <design-2021-school-settings-profile-categories-edit-modal-component
                        :category-in="data.item"></design-2021-school-settings-profile-categories-edit-modal-component>

                    <b-button
                        class="btn-remove"
                        variant="danger-icon-only"
                        @click="deleteCategory(data.item)"
                        :v-b-tooltip="$t('common.delete')"></b-button>
                </div>
            </template>
        </design-2021-apprentice-data-table>
    </div>
</template>

<script>
import { ords } from '../../../app';

export default {
    name: 'design-2021-school-settings-profile-categories-component',
    props: ['categoriesIn'],
    data() {
        return {
            loaded: false,
            categories: [],
            fields: [
                {
                    key: 'title',
                    label: this.$t('common.name'),
                    sortable: true,
                },
                {
                    key: 'color',
                    label: this.$t('common.colour'),
                    sortable: true,
                },
                {
                    key: 'description',
                    label: this.$t('common.description'),
                },
                {
                    key: 'actions',
                    label: this.$t('common.actions'),
                },
            ],
        };
    },
    methods: {
        deleteCategory(category) {
            this.alert
                .confirm(
                    this.$t('school.delete_category'),
                    this.$t('school.are_you_sure_you_want_to_delete_this_category'),
                )
                .then((confirm) => {
                    if (!confirm) {
                        return;
                    }

                    this.alert.saving();

                    this.axios.delete(this.routes.profileCategoryDelete(category.id)).then(
                        (response) => {
                            ords.use('profileCategory').remove(category.id);
                            this.alert.success();
                        },
                        (error) => {
                            this.alert.ajaxError(error);
                        },
                    );
                });
        },

        cssVars(color) {
            return {
                '--category-color': color,
            };
        },
    },
    mounted() {
        if (!this.loaded) {
            ords.use('profileCategory').add(this.categoriesIn);

            ords.use('profileCategory')
                .get()
                .subscribe((category) => {
                    this.categories = category;
                });

            this.loaded = true;
        }
    },
};
</script>

<style scoped lang="scss">
.categories-management-description {
    margin-bottom: map-get($grid-gutter-spacing, 'forty-two');
}

.categories-management-overview-table ::v-deep {
}

.color-icon {
    font-size: $base-font-size;

    i {
        color: var(--category-color);
    }
}

.description {
    width: auto;
    max-width: fit-content;
}

.actions {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;

    .btn {
        font-size: 1.125rem;
        align-self: center;

        &:before {
            margin-right: 0;
        }

        &:not(:last-child) {
            margin-right: map-get($grid-gutter-spacing, 'fifteen');
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'sm')) {
    .categories-management-overview-table ::v-deep {
        .apprentice-table-header {
            flex-direction: row;

            .apprentice-table-filters {
                margin-bottom: 0;
                flex: 0 0 auto;

                .search {
                    max-width: 250px;
                }
            }

            .options {
                flex: 0 0 auto;
            }
        }
    }

    .description {
        max-width: 400px;
        white-space: normal;
    }
}

@media (min-width: map-get($grid-breakpoints, 'md')) {
    .description {
        max-width: 400px;
    }
}

@media (min-width: map-get($grid-breakpoints, 'xl')) {
    .description {
        max-width: fit-content;
    }
}
</style>
